import { getColor } from "../color/color";
import { fonts } from "../fonts/fonts";

export const commanButtomStyled = (activeButton, buttonId, bgColor) => ({
  height: "50px",
  width: "auto",
  fontSize: 16,
  fontFamily: fonts.manrope,
  fontWeight: "500",
  textTransform: "initial",
  color:
    activeButton === buttonId
      ? getColor.PrimaryWhite
      : getColor.SecondaryMidnightBlue,
  backgroundColor:
    activeButton === buttonId
      ? bgColor
      : getColor.ExtendedPalettesSummerSkySS100,
  marginRight: { xs: 0, sm: "20px" },
  marginBottom: { xs: "10px", sm: 0 },
  padding: "15px",
  borderRadius: "10px",
});
